import React from 'react';
import {observer} from 'mobx-react';
import {uniqBy} from 'lodash';
import {toJS} from 'mobx';
import moment from 'moment';
import {
  Button,
  Form,
  Icon,
  Checkbox,
  TextArea,
  Select,
} from 'semantic-ui-react';

import Modal from '../../shared/Modal';
import customFetch from '../../../utils/customFetch';
import DocAndConsStore from './DocAndConsStore';
import {DatePicker, Spin} from 'antd';

const datePickerFormat = 'DD/MM/YYYY';

@observer class ModalActionNotes extends React.Component {
  constructor (props) {
    super (props);
    this.state = {
      DoctorClinic: {
        Id: this.props.modalParams.Id,
        IsActionRequired: DocAndConsStore.dataActionNotes.actionNotes
          .IsActionRequired,
        ActionRequiredStaffId: DocAndConsStore.modalParams.record
          .ActionRequiredStaffId,
        ActionRequiredCompleted: DocAndConsStore.dataActionNotes.actionNotes
          .ActionRequiredCompleted,
        ActionRequiredDate: DocAndConsStore.dataActionNotes.actionNotes
          .ActionRequiredDate,
        ActionRequiredDueDate: DocAndConsStore.dataActionNotes.actionNotes
          .ActionRequiredDueDate,
        ActionRequiredCompletedDate: DocAndConsStore.dataActionNotes.actionNotes
          .ActionRequiredCompletedDate,
        ActionRequiredNote: DocAndConsStore.dataActionNotes.actionNotes
          .ActionRequiredNote,
      },
      staffs: [],
      loading: true,
    };
  }

  async componentDidMount () {
    try {
      const staffsPromise = customFetch ('/MedicalDoctor/GetStaffs', {
        method: 'POST',
      });

      const [staffs] = await Promise.all ([staffsPromise]);

      this.setState ({
        staffs: uniqBy (staffs.itemList, 'Id'),
      });
    } finally {
      this.setState ({loading: false});
    }
  }

  onChangeDisable = () => {
    this.setState(state => ({
      DoctorClinic: {
        ...state.DoctorClinic,
        IsActionRequired: false,}
    }));
  };

  onChangeEnable = () => {
    this.setState(state => ({
      DoctorClinic: {
        ...state.DoctorClinic,
        IsActionRequired: true,}
    }));
  };

  onChangeDateDisable = () => {
    this.setState(state => ({
      DoctorClinic: {
        ...state.DoctorClinic,
        ActionRequiredCompletedDate: null,
        ActionRequiredCompleted: false,}
    }));
  };

  onChangeDateEnable = () => {
    this.setState(state => ({
      DoctorClinic: {
        ...state.DoctorClinic,
        ActionRequiredCompletedDate: moment(Date.now()),
        ActionRequiredCompleted: true,}
    }));
  };

  handlePickerChange = name => momentValue => {
    this.setState (state => ({
      DoctorClinic: {
        ...state.DoctorClinic,
        [name]: momentValue.format(),
      },
    }));
  };

  renderStaffsOptions = () => {
    return toJS (this.state.staffs).map (opt => ({
      text: opt.FullName,
      value: opt.Id,
    }));
  };

  handleFilterStaffs = (_, {value}) => {
    this.setState (state => ({
      DoctorClinic: {
        ...state.DoctorClinic,
        ActionRequiredStaffId: value,
      },
    }));
  };

  handleSubmitActionNotes = async () => {
    DocAndConsStore.setFieldsValue ({loading: true});
    try {
      await customFetch ('/MedicalDoctor/PostActionNotes_Submit', {
        headers: {'Content-Type': 'application/json'},
        method: 'POST',
        body: JSON.stringify ({...this.state.DoctorClinic,
          ActionRequiredDate: moment(this.state.DoctorClinic.ActionRequiredDate).format(),
          ActionRequiredDueDate: moment(this.state.DoctorClinic.ActionRequiredDueDate).format(),
          ActionRequiredCompletedDate: moment(this.state.DoctorClinic.ActionRequiredCompletedDate).format()}),
      }).then (respone => {
        if (respone.status === 'success') {
          this.props.onCancel ();
        }
      });
      await DocAndConsStore.fetchFiles ({}, true);
    } finally {
      DocAndConsStore.setFieldsValue ({loading: false});
    }
  };

  onCancel = () => {
    this.props.onCancel ();
  };
  render () {
    const {open} = DocAndConsStore;
    const {loading, staffs} = this.state;
    return (
      <div className={`Table-${loading && !staffs ? 'loading' : 'container'}`}>
        {loading && !staffs.length
          ? <Spin size="large" className="modal-spin" />
          : <React.Fragment>
              <Modal
                visible={open}
                onCancel={this.props.onCancel}
                footer={
                  <React.Fragment>
                    <Button color="blue" onClick={this.handleSubmitActionNotes}>
                      <Icon name="save" /> Save
                    </Button>
                    <Button color="red" onClick={this.onCancel}>
                      <Icon name="close" /> Close
                    </Button>
                  </React.Fragment>
                }
                title="Action Notes"
              >
                <Form>
                  <Checkbox
                    defaultChecked={this.state.DoctorClinic.IsActionRequired}
                    label="Action Required"
                    onChange={
                      !this.state.DoctorClinic.IsActionRequired
                        ? this.onChangeEnable
                        : this.onChangeDisable
                    }
                  />
                  <Form.Field
                    disabled={
                      !this.state.DoctorClinic.IsActionRequired ? true : false
                    }
                    control={DatePicker}
                    label="Request Date"
                    allowClear={false}
                    format={datePickerFormat}
                    value={
                      this.state.DoctorClinic.ActionRequiredDate
                        ? moment (this.state.DoctorClinic.ActionRequiredDate)
                        : null
                    }
                    onChange={this.handlePickerChange ('ActionRequiredDate')}
                  />
                  <Form.Field
                    disabled={
                      !this.state.DoctorClinic.IsActionRequired ? true : false
                    }
                    control={DatePicker}
                    label="Due Date"
                    allowClear={false}
                    format={datePickerFormat}
                    value={
                      this.state.DoctorClinic.ActionRequiredDueDate
                        ? moment (this.state.DoctorClinic.ActionRequiredDueDate)
                        : null
                    }
                    onChange={this.handlePickerChange ('ActionRequiredDueDate')}
                  />
                  <Form.Field
                    disabled={
                      !this.state.DoctorClinic.IsActionRequired ? true : false
                    }
                    control={Select}
                    options={this.renderStaffsOptions ()}
                    label={{
                      children: 'PIC',
                      htmlFor: 'form-select-control-gender',
                    }}
                    placeholder="Choose PIC"
                    search
                    searchInput={{id: 'form-select-control-gender'}}
                    value={this.state.DoctorClinic.ActionRequiredStaffId}
                    onChange={this.handleFilterStaffs}
                    name="ActionRequiredStaffId"
                  />
                  <Checkbox
                    disabled={
                      !this.state.DoctorClinic.IsActionRequired ? true : false
                    }
                    label="Action completed"
                    onChange={
                      !this.state.DoctorClinic.ActionRequiredCompleted
                        ? this.onChangeDateEnable
                        : this.onChangeDateDisable
                    }
                    defaultChecked={this.state.DoctorClinic.ActionRequiredCompleted ? true : false}
                  />
                  {this.state.DoctorClinic.ActionRequiredCompleted
                    ? <Form.Field
                        disabled={
                          !this.state.DoctorClinic.IsActionRequired
                            ? true
                            : false
                        }
                        control={DatePicker}
                        label="Completed Date"
                        allowClear={false}
                        format={datePickerFormat}
                        value={
                          this.state.DoctorClinic.ActionRequiredCompletedDate
                            ? moment (
                                this.state.DoctorClinic
                                  .ActionRequiredCompletedDate
                              )
                            : moment (Date.now ())
                        }
                        onChange={this.handlePickerChange (
                          'ActionRequiredCompletedDate'
                        )}
                      />
                    : <div />}
                  <Form.Field
                    disabled={
                      !this.state.DoctorClinic.IsActionRequired ? true : false
                    }
                    control={TextArea}
                    label="Action Notes"
                    value={this.state.DoctorClinic.ActionRequiredNote}
                    onChange={v =>
                      this.setState ({
                        DoctorClinic: {
                          ...this.state.DoctorClinic,
                          ActionRequiredNote: v.target.value,
                        },
                      })}
                  />
                </Form>
              </Modal>
            </React.Fragment>}
      </div>
    );
  }
}

export default ModalActionNotes;
